import React from 'react';
import { Button } from '../ui/button';
import {
  TrendingUp,
  BarChart3,
  Users,
  Gift,
  Mic,
  Clock,
  Mail,
  QrCode,
  Sparkles,
  Share2,
  Link2,
  CreditCard,
  Search,
  Activity,
  Smile,
} from 'lucide-react';

/**
 * Admin dashboard primary tab navigation. All 16 tabs live in a single
 * config-driven list so adding/removing a tab is a one-line change. The
 * parent owns `activeTab` and passes a setter.
 */
const TABS = [
  { id: 'overview',   label: 'Overview',        icon: TrendingUp },
  { id: 'analytics',  label: 'Analytics',       icon: BarChart3 },
  { id: 'users',      label: 'Users',           icon: Users },
  { id: 'referrals',  label: 'Outlet Referrals', icon: Gift },
  { id: 'voice',      label: 'Voice Cloning',   icon: Mic },
  { id: 'ads',        label: 'Ad Analytics',    icon: BarChart3 },
  { id: 'promo',      label: 'Promo Codes',     icon: Gift },
  { id: 'moderation', label: 'Moderation',      icon: Clock },
  { id: 'bulk',       label: 'Bulk & Emails',   icon: Mail },
  { id: 'emails',     label: 'Email Templates', icon: Mail },
  { id: 'qr',         label: 'QR Codes',        icon: QrCode },
  { id: 'emojis',     label: 'Comm Emojis',     icon: Smile },
  { id: 'ai-blog',    label: 'AI Blog',         icon: Sparkles },
  { id: 'social',     label: 'Social Media',    icon: Share2 },
  { id: 'notion',     label: 'Notion',          icon: Link2 },
  { id: 'iap',        label: 'IAP Events',      icon: CreditCard },
  { id: 'gsc',        label: 'GSC Indexing',    icon: Search },
  { id: 'health',     label: 'System Health',   icon: Activity },
];

export default function AdminTabsNav({ activeTab, onTabChange }) {
  return (
    <div
      // Always-visible scrollbar so admins know more tabs exist beyond
      // the right edge. Default `overflow-x-auto` hides the scrollbar
      // entirely until you scroll, which the user reported as confusing
      // (they had no idea more tabs were off-screen). The `[&::-webkit-scrollbar-*]`
      // classes give Chrome/Safari a chunky teal scrollbar; Firefox uses
      // `scrollbar-color` via the inline style.
      className="flex gap-2 mb-6 overflow-x-auto pb-3
        [&::-webkit-scrollbar]:h-2.5
        [&::-webkit-scrollbar-track]:rounded-full
        [&::-webkit-scrollbar-track]:bg-muted
        [&::-webkit-scrollbar-thumb]:rounded-full
        [&::-webkit-scrollbar-thumb]:bg-[#00E5CC]/70
        [&::-webkit-scrollbar-thumb:hover]:bg-[#00E5CC]"
      style={{ scrollbarColor: '#00E5CC #e5e7eb', scrollbarWidth: 'thin' }}
      data-testid="admin-tabs-nav"
    >
      {TABS.map(({ id, label, icon: Icon }) => (
        <Button
          key={id}
          variant={activeTab === id ? 'default' : 'outline'}
          size="sm"
          onClick={() => onTabChange(id)}
          data-testid={`tab-${id}`}
        >
          <Icon className="h-4 w-4 mr-1" />
          {label}
        </Button>
      ))}
    </div>
  );
}
